import type { HttpClient } from '@/infrastructure/http/HttpClient'
import type { SharedReceiptFound, SharedReceiptQuery } from '@/domain/rendition/Rendition'
import type { SharedReceiptClaim, SharedReceiptRepository } from '@/domain/rendition/SharedReceiptRepository'
import { sharedReceiptFromApi, type RawSharedReceipt } from '@/infrastructure/rendition/renditionPayload'

export class HttpSharedReceiptRepository implements SharedReceiptRepository {
  constructor(private http: HttpClient) {}

  async findDeclaration(query: SharedReceiptQuery): Promise<SharedReceiptFound | null> {
    const response = await this.http
      .url('purchases/invoice-shares/lookup')
      .params({ number: query.number, emission_date: query.emissionDate, total: String(query.total) })
      .get<{ shared_receipt: RawSharedReceipt | null }>()
    return response.shared_receipt ? sharedReceiptFromApi(response.shared_receipt) : null
  }

  async listMine(): Promise<SharedReceiptFound[]> {
    const response = await this.http.url('purchases/invoice-shares/mine').get<{ results: RawSharedReceipt[] }>()
    return response.results.map(sharedReceiptFromApi)
  }

  // The request timeline renders the leading "@Name" as the mention; the tag itself travels as the user id.
  async claimParticipation(claim: SharedReceiptClaim): Promise<void> {
    await this.http
      .url('purchases/comments')
      .body({ comment: claim.message, process: 'request', pid: claim.requestId, taggedUsers: claim.taggedUserIds })
      .post()
  }
}
